import { Stack } from '@mantine/core';
import useTranslation from 'next-translate/useTranslation';

import { SplashLoader } from '~/domains/common/components/SplashLoader/SplashLoader';
import dt from '~/domains/contest/domains/manage/domains/common/testing.const';
import { Text } from '~/domains/design-system/Text';

export function SectionRedirectingScreen() {
  const { t } = useTranslation('contest');

  return (
    <Stack
      data-test-id={dt.screen.inprogress}
      mih={500}
      h="100%"
      justify="center"
      spacing="xl"
      pt="md"
      mb="md"
    >
      <SplashLoader>
        <Text variant="label-large" ta="center">
          {t('createContest.redirecting.title')} <br />
          {t('createContest.redirecting.description')}
        </Text>
      </SplashLoader>
    </Stack>
  );
}
